module.exports = __webpack_public_path__ + "img/ba.62bd55ec.png";